export function SEAT_MAPS_QUERY() {
    const apiName = 'seatMapsv3';


    return `
    ${apiName}(request: {includePropertyLookup: true}) {
        seatMap {
          departureStation,
          arrivalStation,
          equipmentType,
          equipmentTypeSuffix,
          decks {
            key,
            value {
              compartments {
                key,
                value {
                  units {
                    unitKey,
                    availability,
                    designator,
                    type,
                    group,
                    properties {
                      code,
                      value
                    }
                  }
                }
              }
            }
          }
        }
        fees {
          key,
          value {
            passengerKey,
            groups {
              key,
              value {
                group,
                fees {
                  serviceCharges {
                    type,
                    amount
                  }
                }
              }
            }
          }
        }
      }
`

}